import { Tooltip } from '@nextui-org/react';
import React, { useCallback, useRef, useState } from 'react';

import EnterIcon from '~/assets/EnterIcon';
import { TooltipContent } from '~/components/HelpTooltip/HelpTooltip.styles';

import { SuggestedActionButton, SuggestedActionIcon, SuggestedActionLabel } from './AIInsightsSidebar.styles';

const SuggestedActionItem = ({ label, onClick }: { label: string; onClick: () => void }) => {
  const labelRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = labelRef.current;
    if (el) setIsTruncated(el.scrollWidth > el.offsetWidth);
  }, []);

  const button = (
    <SuggestedActionButton type="button" onClick={onClick} onMouseEnter={checkTruncation}>
      <SuggestedActionIcon>
        <EnterIcon />
      </SuggestedActionIcon>
      <SuggestedActionLabel ref={labelRef}>{label}</SuggestedActionLabel>
    </SuggestedActionButton>
  );

  if (!isTruncated) return button;

  return (
    <Tooltip content={<TooltipContent>{label}</TooltipContent>} placement="top" portalClassName="tooltip-wrapper-big">
      {button}
    </Tooltip>
  );
};

export default SuggestedActionItem;
